import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.scss'
import './index.css'
import App from '@/App'
import { AppProviders } from '@app/providers'
import { AppCrashBoundary } from '@app/AppCrashBoundary'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppCrashBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </AppCrashBoundary>
  </StrictMode>,
)
